export default __webpack_public_path__ + "static/niche-cdf3601cd8ccf1a7e3128b8e8f3c4f25.png";